import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK||'');

export const stripeGetPromise = function(privateKey?: string) {
  return loadStripe(privateKey||'')
}
